<style src="css/psychology.css" scoped></style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="心理咨询"></topbar>
        <div class="typeList">
            <div class="typeItem" :class="{actived:current===index}" v-for="(item,index) in typeList" @click="getList(item.status,index)">{{item.name}}</div>
        </div>
        <div class="infoItem" v-for="item in doctorBespeakList" @click="to(`userDetails?bespeakId=${item.scaleUserBespeak.bespeakId}`)">
            <div class="infoTop" v-if="!item.workId">
                <span>咨询状态：</span><span>{{item.scaleUserBespeak.status | isStatus}}</span>
            </div>
            <div class="infoTop" v-if="item.workId">
                <span>矫正对象</span><span style="color: #F4850D;" @click.stop="to(`taskDetail?workId=${item.workId}`)">详情</span>
            </div>
            <div class="infoContent">
                <div class="userImg"></div>
                <div class="infoContentRight">
                    <div class="name">{{item.userName}}</div>
                    <div class="word" v-if="(JSON.parse(item.scaleUserBespeak.troubles).length>0)"><div class="wordTitle">问题类型：</div><div><span v-for="item in JSON.parse(item.scaleUserBespeak.troubles)">{{item}}</span></div></div>
                    <div class="word"><div class="wordTitle">咨询方式：</div><span>{{item.scaleUserBespeak.serveType | isServeType }}</span></div>
                    <div class="word" v-if="item.scaleUserBespeakSchedules"  v-for="(v,i) in item.scaleUserBespeakSchedules"><div class="wordTitle">第{{i+1}}/{{item.totalCount}}次</div><span>{{v.bespeakDate | time}}</span><span>{{v.status | isStatus}}</span></div>
                    <div class="word" v-if="!item.scaleUserBespeakSchedules"><div class="wordTitle">预约时间：</div><span>{{item.scaleUserBespeak.bespeakDate}}</span></div>
                    <div class="word" v-if="item.scaleUserBespeak.status===4"><div class="wordTitle">取消原因：</div><span>{{item.scaleUserBespeak.remark}}</span></div>
                </div>
            </div>
            <div class="infoBottom" v-if="item.scaleUserBespeak.status!==4">
                <div class="infoBottomBtn cancel" v-if="item.scaleUserBespeak.status===1" @click.stop="startUserBespeakSure(item.scaleUserBespeak.bespeakId,item.scaleUserBespeak.bespeakDate,item.scaleUserBespeak.serveType)">开始咨询</div>
                <div class="infoBottomBtn cancel" v-if="item.scaleUserBespeak.status===2" @click.stop="to(`reply?bespeakId=${item.scaleUserBespeak.bespeakId}`)">继续咨询</div>
                <div class="infoBottomBtn cancel" v-if="item.scaleUserBespeak.status===2" @click.stop="open3(item.scaleUserBespeak.bespeakId)">咨询记录</div>
                <div class="infoBottomBtn change" v-if="item.scaleUserBespeak.status===3" @click.stop="to(`record?typeStatus=1&bespeakId=${item.scaleUserBespeak.bespeakId}`)">咨询记录</div>
                <div class="infoBottomBtn change" v-if="item.scaleUserBespeak.status===1||item.scaleUserBespeak.status===2||item.scaleUserBespeak.status===3" @click.stop="to(`selectTime?userId=${item.scaleUserBespeak.userId}`)">再次预约</div>
                <div class="infoBottomBtn change" v-if="item.scaleUserBespeak.status!==3" @click.stop="openMask(item.scaleUserBespeak.bespeakId)">取消</div>
<!--                <div class="infoBottomBtn change" v-if="item.scaleUserBespeak.status===3" @click.stop="to(`evaluate`)">查看评价</div>-->
            </div>
        </div>
        <no-more-data :noMoreData="noMoreData"></no-more-data>

        <div class="maskBox" v-if="maskStatus">
            <div class="mask">
                <div class="maskTop">
                    <div class="maskTitle">说明取消原因</div>
                    <textarea maxlength="30" placeholder="最多输入30个字" v-model="remark"></textarea>
<!--                    <input type="text" maxlength="30" placeholder="最多输入30个字" v-model="remark">-->
                </div>
                <div class="btnBox">
                    <div class="btn" @click="cancle">取消</div>
                    <div class="btn active" @click="cancelUserBespeak">提交</div>
                </div>
            </div>
        </div>
        <div class="maskBox" v-if="maskStatus2">
            <div class="mask">
                <div class="maskTop">
                    <div class="maskTitle" style="margin-bottom: 0">用户预约的是<span style="color:#00C59F;">{{time}}</span>的{{name}}。您确定要现在开始咨询？</div>
                </div>
                <div class="btnBox">
                    <div class="btn" @click="cancle">取消</div>
                    <div class="btn active" @click="startUserBespeak(bespeakId)">确定</div>
                </div>
            </div>
        </div>
        <div class="maskBox" v-if="maskStatus3">
            <div class="mask">
                <div class="maskTop">
                    <div class="maskTitle" style="margin-bottom: 0">请在咨询结束后及时填写咨询记录？</div>
                </div>
                <div class="btnBox">
                    <div class="btn" @click="cancle">取消</div>
                    <div class="btn active" @click="getBespeakTagList()">去填写</div>
                </div>
            </div>
        </div>

        <div class="tipBox" v-if="tipStatus">
            <div class="tip">{{tip}}</div>
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                tipStatus:false,
                maskStatus2:false,
                maskStatus3:false,
                tip:'',
                typeList:[
                    {
                        name:'全部',
                        status:''
                    },{
                        name:'待咨询',
                        status: 1
                    },{
                        name:'进行中',
                        status: 2
                    },{
                        name:'已完成',
                        status: 3
                    },{
                        name:'已取消',
                        status: 4
                    },
                ],
                current: 0,
                status: '',
                pageIndex: 1,
                pageSize: 10,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                count: 0,
                doctorBespeakList:[],

                maskStatus: false,
                remark: '',
                bespeakId:'',
                time:'',
                name:'',
                companyId:''
            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {

            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            isStatus(v){
                let arr = ['预约中','待咨询','进行中','已完成','已取消']
                return arr[v]
            },

            isServeType(v){
                let arr = ['图文咨询','电话咨询','视频咨询','线下咨询']
                return arr[v]
            }
        },
        computed: {},
        methods: {
            isSureTo(){
                this.to(`record?bespeakId=${this.bespeakId}`)
            },
            isServeType(v){
                let arr = ['图文咨询','电话咨询','视频咨询','线下咨询']
                return arr[v]
            },
            startUserBespeakSure(bespeakId,time,name){
                this.bespeakId=bespeakId;
                this.time= time
                this.name= this.isServeType(name)
                this.maskStatus2=true;
            },
            async getBespeakTagList() {
                let data = await getSources("/bear-scale/api/scaleUserBespeakTag/getBespeakTagList",{
                    companyId:this.companyId
                });
                if (data.status === 0) {
                    if(data.tagList.length>0){
                        this.to(`label?bespeakId=${this.bespeakId}`)
                    }else{
                        this.isSureTo()
                    }
                }else{
                    this.showTip(data.msg)
                }
            },
            async startUserBespeak(bespeakId) {
                let data = await getSources("/bear-scale/api/scaleUserBespeak/startUserBespeak.json",{
                    doctorId:localStorage.getItem('doctorId'),
                    bespeakId:bespeakId
                });
                if (data.status === 0) {
                    this.to(`reply?bespeakId=${bespeakId}`)
                }else{
                    this.showTip(data.msg)
                }
            },
            showTip(v){
                this.tip=v;
                this.tipStatus=true;
                setTimeout(()=>{
                    this.tipStatus=false;
                },1500)
            },
            to(n){
                this.$router.push(n)
            },
            cancle(){
                this.maskStatus = false
                this.maskStatus2 = false
                this.maskStatus3 = false
                this.bespeakId = ''
            },
            open3(id){
                this.bespeakId=id;
                this.maskStatus3=true;
            },
            openMask(id){
                this.bespeakId=id;
                this.maskStatus=true;
            },

            async cancelUserBespeak() {
                if(!this.remark){
                    alert(`请输入原因`)
                    return
                }
                let obj = {}
                obj.bespeakId = this.bespeakId;
                obj.doctorId = localStorage.getItem('doctorId');
                obj.remark = this.remark;
                let data = await getSources("/bear-scale/api/scaleUserBespeak/cancelUserBespeak.json", obj);
                if (data.status === 0) {
                    this.cancle();
                    this.pageIndex=1;
                    this.doctorBespeakList=[];
                    this.getDoctorBespeakList();
                }else{
                    this.showTip(data.msg)
                }
            },
            getList(n,index){
                this.doctorBespeakList=[];
                this.current = index
                this.pageIndex=1;
                this.status = n;
                this.getDoctorBespeakList()
            },
            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getDoctorBespeakList()
                    }
                }
            },
            async getDoctorBespeakList() {
                let obj = {}
                obj.pageIndex = this.pageIndex;
                obj.pageSize = this.pageSize;
                obj.status = this.status;
                obj.doctorId = localStorage.getItem('doctorId');
                let data = await getSources("/bear-scale/api/scaleUserBespeak/getDoctorBespeakList.json", obj);
                if (data.status === 0) {
                    this.isLoading = false;
                    this.count = data.count;
                    this.doctorBespeakList = [...this.doctorBespeakList, ...data.doctorBespeakList];
                    if (data.doctorBespeakList.length == 0) {
                        this.noMoreData = true
                    } else {
                        console.log(111111)
                        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                            console.log('显示')
                            this.noMoreData = true
                        } else {
                            console.log(2)
                            this.noMoreData = false
                        }
                    }

                }else{
                    this.showTip(data.msg)
                }
            },
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.companyId=localStorage.getItem('companyId')?localStorage.getItem('companyId'):''
            if(this.$route.query.current>=0){
                if(parseInt(this.$route.query.current)===0){
                    this.getList('',0)
                }else{
                    this.getList(parseInt(this.$route.query.current),parseInt(this.$route.query.current))
                }
            }else{
                this.getDoctorBespeakList();
            }
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/psychology.vue